import FrameworkCategory from '../models/FrameworkCategory';
import Data from './Data';

class FrameworkCategories extends Data {
    constructor() {
        super(FrameworkCategory);
    }
}

export default new FrameworkCategories();
